import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { showBanner } from '../../global-state/banner-slice'
import {
  comingSoonAdminServices,
  type ComingSoonAdminRow,
} from '../../services/coming-soon-admin-service'
import { ComingSoonListPresenter } from './coming-soon-list-presenter'

export function ComingSoonListContainer() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [items, setItems] = useState<ComingSoonAdminRow[]>([])
  const [isLoading, setIsLoading] = useState(true)

  const load = useCallback(async () => {
    try {
      setIsLoading(true)
      const list = await comingSoonAdminServices.listAll()
      setItems(list)
    } catch {
      dispatch(showBanner({ text: 'Failed to load coming soon items', variant: 'error-banner' }))
      setItems([])
    } finally {
      setIsLoading(false)
    }
  }, [dispatch])

  useEffect(() => {
    void load()
  }, [load])

  const onDelete = async (id: number) => {
    if (!window.confirm('Delete this coming soon item?')) return
    try {
      await comingSoonAdminServices.remove(String(id))
      dispatch(showBanner({ text: 'Deleted', variant: 'success-banner' }))
      await load()
    } catch {
      dispatch(showBanner({ text: 'Delete failed', variant: 'error-banner' }))
    }
  }

  return (
    <ComingSoonListPresenter
      items={items}
      isLoading={isLoading}
      onAdd={() => navigate('/coming-soon/new')}
      onEdit={(id) => navigate(`/coming-soon/${id}/edit`)}
      onDelete={onDelete}
    />
  )
}
